export default function durationFormatDate(duration, translate = null) {
  let years = Math.floor(duration / (60 * 60 * 24 * 30 * 12)),
    months = Math.floor(duration / (60 * 60 * 24 * 30)),
    days = Math.ceil(duration / (60 * 60 * 24));
  return translate
    ? years > 0
      ? translate("ra.text.profileBar.years")
      : months > 0
      ? translate("ra.text.profileBar.months")
      : translate("ra.text.profileBar.days")
    : years > 0
    ? years
    : months > 0
    ? months
    : days;
}
